export class SurveyModel {
  constructor() {
    this.id = null;
    this.name = null;
    this.description = null;
    this.status =  null;
    this.activeFrom = null;
    this.activeTo = null;
    this.createdAt = null;
    this.updatedAt = null;
    this.form = null;
    this.respondentProfile = null;
    this.comments = [];
    this.participationConstraints = {
      requireNonGovernmentOrganization: false,
      requireSubordinateOrganization: false,
      requireVerification: false,
    };
    this.boardSettings = {};
    this.participantsVerification = {};
  }
}



// WEBPACK FOOTER //
// ./src/models/survey/SurveyModel.js